import { buildRadioButtonInput } from "../inputs/buildRadioButtonInput";
import { buildCheckboxInput } from "../inputs/buildCheckboxInput";
import { buildRadioIconInput } from "../inputs/buildRadioIconInput";
import { buildTextareaInput } from "../inputs/buildTextareaInput.js";

const additionalTemplate = ({ classes, model, section }) => {
	const errorMessageAdditional = `error-message--${section.key}`;
	const formType = section.fields[0].type;

	return `
        <div class="${classes.rootClass}__event-info">
        <h4>${model.texts.introLabel} ${model.eventModel.name}</h4>
        <time
            data-async-module="local-datetime"
            data-date-format="event-date-time"
            data-utc-start="${model.eventModel.startDateUTC}"
            data-utc-end="${model.eventModel.endDateUTC}"
            data-date-fallback="${model.eventModel.dateString}"
            data-use-ksa="true"
        ></time>
        </div>
        <div class="${classes.rootClass}__section">
            <fieldset class="${classes.rootClass}__fieldset">
                <legend class="visuallyhidden">${section.title}</legend>
                ${formType === "DropDownList" ?
									`<div class="${classes.rootClass}__checkbox-group ${classes.rootClass}__checkbox-group--default">
										<h3>${section.title}</h3>
										<p>${section.description}</p>
										<ul class="${classes.rootClass}__vertical-list">
												${buildCheckboxInput(
													section.fields[0],
													errorMessageAdditional,
													true
												)}
										</ul>
										<p class="${errorMessageAdditional}"></p>
									</div>`
									: ""
								}
                ${(formType === "RadioButtonList" || formType === "ButtonList") ?
									`<div class="${classes.rootClass}__radio-group ${classes.rootClass}__radio-group--button">
											<h3>${section.title}</h3>
											<p>${section.description}</p>
											<ul class="${classes.rootClass}__stacking-list">
												${buildRadioButtonInput(
													section.fields[0],
													errorMessageAdditional,
													true
												)}
											</ul>
											<p class="${errorMessageAdditional}"></p>
									</div>`
									: ""
								}
                ${formType === "IconRadioButtons" ?
									`<div class="${classes.rootClass}__radio-group ${classes.rootClass}__radio-group--icon">
											<h3>${section.title}</h3>
											<p>${section.description}</p>
											<ul class="${classes.rootClass}__horizontal-list">
													${buildRadioIconInput(
														section.fields[0],
														classes,
														errorMessageAdditional,
														true
													)}
											</ul>
											<p class="${errorMessageAdditional}"></p>
									</div>`
									: ""
								}
                ${formType === "TextInput" ?
									`<div class="${classes.rootClass}__textarea-group input ${classes.rootClass}__textarea-group--default">
                    <h3>${section.title}</h3>
											<p>${section.description}</p>
											${buildTextareaInput(section.fields[0], true)}
											<p class="${errorMessageAdditional}"></p>
									</div>`
									: ""
								}
            </fieldset>
        </div>
    `;
};

export default additionalTemplate;
